'use client';

import { c as _c } from "react/compiler-runtime";
import { ApiErrors } from '@repo/features/error';
import { Alert, AlertDescription, Button, FieldGroup, FieldLabel, FieldSet, Spinner } from '@repo/ui/components';
import Link from 'next/link';
import { useLoginForm } from '@/app/@public/_components/login-form/hook.ts';
export const LoginForm = () => {
  const $ = _c(26);
  const {
    errorMessage,
    form,
    isPending,
    resetSuccess
  } = useLoginForm();
  let t0;
  if ($[0] !== form) {
    t0 = async e => {
      e.preventDefault();
      await form.handleSubmit();
    };
    $[0] = form;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== resetSuccess) {
    t1 = resetSuccess && <Alert><AlertDescription>Your password has been reset. Please log in with your new password.</AlertDescription></Alert>;
    $[2] = resetSuccess;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  let t3;
  if ($[4] !== form.AppField) {
    t2 = <form.AppField children={_temp} name="email" data-sentry-element="form.AppField" data-sentry-source-file="form.tsx" />;
    t3 = <form.AppField children={_temp2} name="password" data-sentry-element="form.AppField" data-sentry-source-file="form.tsx" />;
    $[4] = form.AppField;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isPending) {
    t4 = isPending && <Spinner />;
    $[7] = isPending;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isPending || $[10] !== t4) {
    t5 = <Button disabled={isPending} type="submit" data-sentry-element="Button" data-sentry-source-file="form.tsx">Login {t4}</Button>;
    $[9] = isPending;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== errorMessage) {
    t6 = <ApiErrors errors={errorMessage} data-sentry-element="ApiErrors" data-sentry-source-file="form.tsx" />;
    $[12] = errorMessage;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== t3 || $[17] !== t5 || $[18] !== t6) {
    t7 = <FieldSet data-sentry-element="FieldSet" data-sentry-source-file="form.tsx"><FieldGroup data-sentry-element="FieldGroup" data-sentry-source-file="form.tsx">{t1}{t2}{t3}{t5}{t6}</FieldGroup></FieldSet>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t0 || $[21] !== t7) {
    t8 = <form onSubmit={t0}>{t7}</form>;
    $[20] = t0;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== form.AppForm || $[24] !== t8) {
    t9 = <form.AppForm data-sentry-element="form.AppForm" data-sentry-component="LoginForm" data-sentry-source-file="form.tsx">{t8}</form.AppForm>;
    $[23] = form.AppForm;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
};
function _temp(fieldApi) {
  return <fieldApi.Input label="Email" placeholder="Email" />;
}
function _temp2(fieldApi_0) {
  return <fieldApi_0.PasswordInput autoComplete="current-password" label={<div className="flex flex-col-reverse items-center justify-between gap-2 sm:flex-row sm:gap-0"><FieldLabel htmlFor="password">Password</FieldLabel><Link className="text-sm underline" href="/forgot-password">Forgot your password?</Link></div>} placeholder="Password" />;
}